// extracted by mini-css-extract-plugin
module.exports = {"moduleRoot":"FlexImage_moduleRoot___0jCU"};